import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {TagPill} from '../CrmTagPill/CrmTagPill';

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

const CrmTicketTags = ({tags}) => {
  if (!tags.length) return <>-</>;

  return (
    <Container>
      {tags.map((tag) => (
        <TagPill key={tag.id || tag.tag} color={tag.color}>
          {tag.tag}
        </TagPill>
      ))}
    </Container>
  );
};

CrmTicketTags.propTypes = {
  tags: PropTypes.array,
};

export default CrmTicketTags;
